import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Zap, Gamepad2, Trophy } from 'lucide-react';

const Index = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 flex flex-col">
      {/* Animated background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-96 h-96 bg-orange-500 rounded-full mix-blend-multiply filter blur-3xl opacity-10"></div>
        <div className="absolute top-40 right-10 w-96 h-96 bg-cyan-500 rounded-full mix-blend-multiply filter blur-3xl opacity-10"></div>
      </div>

      {/* Hero Section */}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-4 text-center">
        <div className="mb-8">
          <div className="text-7xl mb-4">🏎️</div>
          <h1 className="text-5xl md:text-7xl font-black bg-gradient-to-r from-orange-400 via-red-400 to-cyan-400 bg-clip-text text-transparent mb-4">
            EXTREME RACING
          </h1>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto">
            Master extreme racing. Customize your vehicles. Dominate the competition.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-8 my-12 text-4xl">
          <span title="Speed">⚡</span>
          <span title="Drift">🌪️</span>
          <span title="Victory">👑</span>
        </div>

        <Button
          onClick={() => navigate('/game')}
          className="bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-bold text-lg py-7 px-10 rounded-lg transition-all transform hover:scale-105"
        >
          <Zap className="w-6 h-6 mr-2" />
          START RACING
        </Button>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-12 max-w-3xl">
          <div className="bg-white/5 backdrop-blur border border-white/10 rounded-lg p-6">
            <Zap className="w-6 h-6 text-orange-400 mb-2" />
            <p className="font-semibold">Quick Race</p>
            <p className="text-sm text-slate-400">Jump into action</p>
          </div>
          <div className="bg-white/5 backdrop-blur border border-white/10 rounded-lg p-6">
            <Trophy className="w-6 h-6 text-orange-400 mb-2" />
            <p className="font-semibold">Time Trial</p>
            <p className="text-sm text-slate-400">Beat your record</p>
          </div>
          <div className="bg-white/5 backdrop-blur border border-white/10 rounded-lg p-6">
            <Gamepad2 className="w-6 h-6 text-orange-400 mb-2" />
            <p className="font-semibold">Championship</p>
            <p className="text-sm text-slate-400">Win the title</p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="relative z-10 border-t border-slate-800 py-6 px-4 text-center text-slate-400 text-sm">
        <p>Extreme racing awaits. Are you ready?</p>
      </footer>
    </div>
  );
};

export default Index;